import { HalfMarathonInAngkorWat, SiemReapTrip } from "./ArticleList/Cambodia";
import { JobFindingInSG, SingaporeLiving } from "./ArticleList/Singapore";
import { VietnamItinerary } from "./ArticleList/Vietnam";
import { baliItinerary, baliSurf, mtBromoTour } from "./ArticleList/Indonesia";

import vietnamPropaganda from "/Img/country/Vietnam/propaganda.jpg";
import MBS from "/Img/country/Singapore/MBS.jpg";
import hiltonView from "/Img/country/Singapore/hiltonView.jpg";
import sgCityLine from "/Img/country/Singapore/sgCityLine.jpeg";
import siemReapTemple from "/Img/country/Cambodia/temple1.jpeg";
import siemReapTitle from "/Img/country/Cambodia/siemReapTitle.jpeg";
import surfBali from "/Img/country/Indonesia/Bali/surf.webp";
import templePraying from "/Img/country/Indonesia/Bali/templePraying.jpg";
import volcano from "/Img/country/Indonesia/Bromo/volcano.jpeg";
import volcano2 from "/Img/country/Indonesia/Bromo/volcano2.jpeg";

const CountryDetailedList = [
  //Singapore
  {
    img: sgCityLine,
    title: "新加坡找工作和簽證分享",
    description:
      "在新加坡找工作的完整指南，涵蓋EP、SP等工作準證的申請流程、薪資要求與常見注意事項，適合計畫來新加坡工作的台灣人閱讀。",
    titleImgText: "新加坡城市一景",
    countryKey: "Singapore",
    countryName: "新加坡",
    link: "/Your-Ultimate-Guide-to-Job-Finding-and-Visas-in-Singapore",
    content: JobFindingInSG,
  },

  {
    img: hiltonView,
    title: "實際在新加坡生活要多少錢？",
    description:
      "2023年在新加坡生活的實際費用全面分析，包含住房、交通、餐飲等各項開銷的真實數據，幫助你評估在新加坡生活所需的預算。",
    titleImgText: "新加坡城市的邊際線",
    countryKey: "Singapore",
    countryName: "新加坡",
    link: "/The-Realistic-Cost-of-Living-in-Singapore-in-2023:-A-Practical-Guide",
    content: (currentLang) => SingaporeLiving(currentLang),
  },

  //Indonesia
  {
    img: volcano,
    title: "印尼布羅莫火山(mount Bromo)日出：你所需要知道的一切！",
    description:
      "印尼布羅莫火山（Mount Bromo）日出全攻略，包含最佳觀景地點、交通方式、住宿推薦與拍攝技巧，讓你完美掌握這趟壯觀的火山之旅。",
    titleImgText: "印尼布羅莫火山",
    countryKey: "Indonesia",
    countryName: "印尼",
    link: "/Mount-Bromo-Sunrise:-Everything-You-Need-To-Know",
    content: mtBromoTour,
  },
  {
    img: templePraying,
    title: "我的七天巴厘島旅程 --- 衝浪、絕美沙灘跟古寺廟",
    description:
      "七天巴厘島自由行完整行程分享，包含衝浪體驗、烏布古廟、絕美沙灘等必訪景點，以及交通和住宿的實用建議。",
    titleImgText: "遊客在聖泉寺祈禱",
    countryKey: "Indonesia",
    countryName: "印尼",
    link: "/My-One-Week-Solo-Trip-to-Bali:-Temples,-Surfing,-and-Beaches",
    content: baliItinerary,
  },

  {
    img: surfBali,
    title: "菜鳥浪人在巴厘島的衝浪心得",
    description:
      "巴厘島初學者衝浪體驗完整記錄，分享最佳衝浪地點、衝浪課程費用與技巧心得，以及作為初次衝浪者的真實感受與建議。",
    titleImgText: "Ola Eleogram and Eli Olson Photo: Tony Heff",
    countryKey: "Indonesia",
    countryName: "印尼",
    link: "/My-First-Surfing-Adventure-in-Bali-As-An-Beginner",
    content: baliSurf,
  },

  //thailand
  // {
  //   img: volcano,
  //   title: "Mount-Bromo-Sunrise:-Everything-You-Need-To-Know",
  //   titleImgText: "Mount-Bromo-Sunrise:-Everything-You-Need-To-Know_ImgText",
  //   countryKey: "Indonesia",
  //   link: "/Mount-Bromo-Sunrise:-Everything-You-Need-To-Know",
  //   content: mtBromoTour,
  // },

  //India
  // {
  //   img: sgCityLine,
  //   title: "Your-Ultimate-Guide-to-Job-Finding-and-Visas-in-Singapore",
  //   titleImgText:
  //     "Your-Ultimate-Guide-to-Job-Finding-and-Visas-in-Singapore_ImgText",
  //   countryKey: "India",
  //   countryName: "印度",
  //   link: "/Your-Ultimate-Guide-to-Job-Finding-and-Visas-in-Singapore",
  //   content: JobFindingInSG,
  // },

  //vietnam
  {
    img: vietnamPropaganda,
    title: "越南18天深度行程：從胡志明市到河內的完整攻略",
    description:
      "越南18天南北縱貫旅遊行程全攻略，涵蓋胡志明市、會安、海雲關、峰牙洞穴群、寧平、沙壩梯田到河內，附交通費用與景點詳細介紹。",
    titleImgText: "越南街頭的宣傳海報",
    countryKey: "Vietnam",
    countryName: "越南",
    link: "/Vietnam-18-Day-Travel-Itinerary",
    content: VietnamItinerary,
  },

  //cambodia

  {
    img: siemReapTitle,
    title: "在吳哥窟遺址中挑戰人生第一場半馬！",
    description:
      "在柬埔寨吳哥窟世界遺址挑戰人生第一場半程馬拉松的完整記錄，包含賽事資訊、備賽心得、比賽當天體驗，以及馬拉松與旅遊結合的行程建議。",
    titleImgText: "早上日出的吳哥窟",
    countryKey: "Cambodia",
    countryName: "柬埔寨",
    link: "/Half-Marathon-In-AngKor-Wat",
    content: HalfMarathonInAngkorWat,
  },
  {
    img: siemReapTemple,
    title: "暹粒(siem reap)的吳哥窟古城三日遊",
    description:
      "柬埔寨暹粒吳哥窟三日遊完整攻略，帶你探索世界最大宗教建築群，包含各大神廟介紹、交通方式、最佳遊覽時間與省錢小貼士。",
    titleImgText: "暹粒吳哥窟的古老神廟",
    countryKey: "Cambodia",
    countryName: "柬埔寨",
    link: "/Siem-Reap-Travel",
    content: SiemReapTrip,
  },
];

export default CountryDetailedList;
